import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

// Input — basic text input matching the INPUT constant duplicated across the
// settings forms. Forwards ref + all native <input> props.
//
// Props (in addition to native):
//   - size?: 'sm' | 'md'   (default 'md')
//   - invalid?: boolean    (red border)
//   - className?: string

const SIZE_STYLES = {
  sm: 'h-8 text-sm',
  md: 'h-10 text-sm',
};

export const Input = forwardRef(function Input(
  { size = 'md', invalid, className, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'w-full rounded-lg border bg-bg px-3 text-fg',
        'placeholder:text-fg-subtle',
        'focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        SIZE_STYLES[size] ?? SIZE_STYLES.md,
        invalid ? 'border-status-error' : 'border-border',
        className,
      )}
      {...rest}
    />
  );
});

Input.displayName = 'Input';

export default Input;
